import { gql } from '@apollo/client'

export const COACH_ONBOARDING_PROGRESS = gql`
  query CoachOnboardingProgress {
    currentUser {
      attributes {
        ... on Coach {
          coachProfile {
            id
          }
          pgaMembership {
            admCertified
          }
          preferences {
            bookNowEnabled
          }
        }
      }
      students(limit: 1) {
        id
      }
      groupEvents(limit: 1) {
        id
      }
    }
    lessonTypes {
      id
    }
    lightspeedCourseSummary {
      completedAdmCourseCount
      totalAdmCourseCount
    }
  }
`
